import { render } from "./ChatRoom.vue?vue&type=template&id=2b146e1a&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"

import "./ChatRoom.vue?vue&type=style&index=0&id=2b146e1a&scoped=true&lang=css"
import "./ChatRoom.vue?vue&type=style&index=1&id=2b146e1a&lang=css"

import exportComponent from "/Users/xueke/Develop/Work/rococo/weshow-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b146e1a"]])

export default __exports__